import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { useMemo } from "react";
import { Autocomplete } from "./Autocomplete";
import "./Autocomplete.scss";

export const AutocompleteFormComponent = ({
    input,
    fieldProps,
    fieldAttr,
    meta,
}: FormComponentProps) => {
    const { options, defaultValue, ...restProps } = fieldProps;

    // Handle different defaultValue formats:
    // - In "create new" screens: defaultValue is a simple ID (string/number)
    //   → Exclude from defaultValue prop, pass as value via react-form
    // - In other contexts: defaultValue is an object with {value, label} structure
    //   → Pass as defaultValue prop to Autocomplete component
    const defaultAutocompleteValue = useMemo(() => {
        if (defaultValue === undefined || defaultValue?.value !== undefined) {
            return { defaultValue };
        } else return {};
    }, [defaultValue]);
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Autocomplete
                name={input.name}
                options={options}
                value={input.value}
                additionalProps={{ fieldWidth: 420, ...restProps, ...fieldAttr }}
                onChange={input.onChange}
                onBlur={input.onBlur}
                {...defaultAutocompleteValue}
            />
        </Input>
    );
};
